import { render, staticRenderFns } from "./process-purpose-dropdown.vue?vue&type=template&id=3eb2ce31"
import script from "./process-purpose-dropdown.vue?vue&type=script&lang=js"
export * from "./process-purpose-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports